import { cn } from '@sparklayer-io/spark-dash-ui/lib/styles';
import { Icon } from '@ui/themed';

/** The small coloured status dot each accordion row shows next to its title. */
export function OnboardingStepIcon({ complete }: { complete: boolean }) {
  return (
    <span
      className={cn(
        'flex size-8 shrink-0 items-center justify-center rounded-full text-white',
        complete ? 'bg-green-400' : 'bg-spark-control-disabled-thumb',
      )}
    >
      <Icon name={complete ? 'check' : 'circle'} size="sm" />
    </span>
  );
}
